<template>
  <v-app data-psych-doctor-information>
    <v-icon
      @click="clickHandle"
    >
      ui-icon-circle-info
    </v-icon>
    <v-bottom-sheet
      v-if="isMobile"
      v-model="isActive"
    >
      <v-sheet>
        <div class="bottom-sheet-container px-4 py-6">
          <div class="text-h6 text--text">
            {{ props.title }}
          </div>
          <div
            v-if="props.subtitle"
            class="text-body-1 text-secondary--text"
          >
            {{ props.subtitle }}
          </div>
          <div class="my-4 text-body-1 text--text">
            {{ props.description }}
          </div>
          <v-btn
            block
            color="bg-primary--text"
            elevation="0"
            @click="clickHandle"
          >
            <span class="primary--text">
              {{ $t('Понятно', { ns: $i18next.language }) }}
            </span>
          </v-btn>
        </div>
      </v-sheet>
    </v-bottom-sheet>
    <CoreDialog
      v-else
      v-model="isActive"
      data-qa="psych-doctor-information-modal"
      size="lg"
      divider
    >
      <template #prependBtn="{ btnProps }">
        <v-btn
          v-bind="btnProps"
          @click="clickHandle"
        >
          <span class="ui-icon-close-not-a-circle" />
        </v-btn>
      </template>
      <template #title>
        {{ props.title }}
        <div
          v-if="props.subtitle"
          class="text-body-2 text-secondary--text"
        >
          {{ props.subtitle }}
        </div>
      </template>
      <div class="text-body-1 text-secondary--text">
        {{ props.description }}
      </div>
      <template #actions>
        <v-btn
          data-qa="modal-actions-btn-close"
          color="primary"
          elevation="0"
          @click="clickHandle"
        >
          {{ $t('Понятно', { ns: $i18next.language }) }}
        </v-btn>
      </template>
    </CoreDialog>
  </v-app>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { VBottomSheet } from 'vuetify/lib'
import CoreDialog from 'src/core/CoreDialog/CoreDialog.vue'

const props = defineProps<{
  title: string
  subtitle?: string
  description: string
}>()

const isActive = ref(false)
const isMobile = window.MOBILE_VERSION

function clickHandle() {
  isActive.value = !isActive.value
}
</script>

<style lang="scss">
@import '~www/themes/doctors/common/mixins';

#app[data-psych-doctor-information] {
  @include v-app-reset;
}
</style>

<style lang="scss" scoped>
.bottom-sheet-container {
  overflow-y: auto;
  max-height: 90vh;
}
</style>
